var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmplifyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 18.8888C40 17.2479 39.1007 15.8305 37.7778 15.0611V4.44508C37.7778 3.83745 37.2931 2.22217 35.5556 2.22217C35.0611 2.22217 34.5701 2.38745 34.1681 2.70967L28.2632 7.43397C25.2972 9.80481 21.5736 11.1111 17.7778 11.1111H4.44444C1.98958 11.1111 0 13.1006 0 15.5555V22.2222C0 24.677 1.98958 26.6666 4.44444 26.6666H6.78472C6.68819 27.3944 6.63333 28.1347 6.63333 28.8888C6.63333 31.6506 7.27639 34.2604 8.40833 36.593C8.76875 37.3354 9.55556 37.7777 10.3806 37.7777H15.5389C17.3479 37.7777 18.434 35.7055 17.3375 34.2666C16.1986 32.7722 15.5215 30.9083 15.5215 28.8888C15.5215 28.1173 15.634 27.3756 15.8278 26.6666H17.7778C21.5736 26.6666 25.2972 27.9729 28.2625 30.3437L34.1674 35.068C34.5612 35.3832 35.0505 35.5551 35.5549 35.5555C37.2854 35.5555 37.7771 33.9736 37.7771 33.3333V22.7173C39.1007 21.9472 40 20.5298 40 18.8888ZM33.3333 28.7097L31.0382 26.8736C27.2882 23.8736 22.5778 22.2222 17.7778 22.2222V15.5555C22.5778 15.5555 27.2882 13.9041 31.0382 10.9041L33.3333 9.068V28.7097Z",
    fill: "#F3B6FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplifyIcon);
export default __webpack_public_path__ + "static/media/amplify-icon.356127332b661849b65167375c2e6545.svg";
export { ForwardRef as ReactComponent };